// extracted by mini-css-extract-plugin
module.exports = {"root":"product_root__mqt3v","relatedProducts":"product_relatedProducts__geW4b","hero":"product_hero__I2amx"};